<div class="layout-topbar"
     [ngClass]="{
    'topbar-inactive': configService.config.menuMode !== 'horizontal',
    'topbar-active': configService.config.menuMode === 'horizontal'}">
    <div class="layout-topbar-wrapper">
        <div class="layout-topbar-left">
            <a tabindex="0" class="menu-button" (click)="app.onMenuButtonClick($event)">
                <i class="pi pi-bars"></i>
            </a>
            <!--<a tabindex="0"
       class="layout-topbar-logo"
       style="position: relative; top: -10px;"
       (click)="app.onMenuButtonClick($event)">
    </a>-->
            <a tabindex="0" id="logo-link" class="layout-topbar-logo" style="position: relative; top: -10px;" (click)="app.onMenuButtonClick($event)">
                <img [src]="'\XpressApp\assets\layout\images\xpress-logo.png'" alt="xpress-layout" />
            </a>
        </div>

        <menu></menu>

        <div class="layout-topbar-right">
            <!--
        <ul class="layout-topbar-actions">
            <li #searchItem class="topbar-item search-item" [ngClass]="{'active-topmenuitem': app.search}">
                <a tabindex="0" (click)="app.onTopbarItemClick($event,searchItem)">
                    <i class="topbar-icon pi pi-search"></i>
                </a>

                <div class="search-input-wrapper">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Search..." (click)="app.searchClick = true;" />
                    </span>
                </div>

                <ul class="fadeInDown">
                    <div class="search-input-wrapper p-fluid" style="width: 100%">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input type="text" pInputText placeholder="Search..." (click)="app.searchClick = true;" />
                        </span>
                    </div>
                </ul>
            </li>

            <li #profile class="topbar-item user-profile" [ngClass]="{'active-topmenuitem fadeInDown': app.activeTopbarItem === profile}">
                <a href="#" (click)="app.onTopbarItemClick($event,profile)">
                    <img src="assets/layout/images/avatar-profilemenu.png" alt="freya-layout" />
                </a>
                <ul class="fadeInDown">
                    <li>
                        <a href="#">
                            <span>Profile</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <span>Settings</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <span>Messages</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <span>Notifications</span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
        -->

            <div class="filler"></div>

            <!--
        <a href="#" tabindex="0" class="layout-rightpanel-button" (click)="app.onRightPanelClick($event)">
            <i class="pi pi-arrow-left"></i>
        </a>
        -->
        </div>
    </div>
</div>
